<ng-content />
<span class="bz-tooltip-bubble" role="tooltip" [id]="id">{{ content() }}</span>
